import React from 'react';
import  './styles.css'
import { Container, Row } from "reactstrap";
import Testimonials from '../../components/Testimonials/Testimonials';


function TestimonialPage() {
    return ( <Container>
        <Row className='Title'>
            <h2>Testimonials</h2>
            <img className="Main-photo" width="640" height="450" alt='group' src={'/images/photos/hannah-busing-Zyx1bK9mqmA-unsplash.webp'} />
        </Row>
        <Row>
            <div>
                <Testimonials/>
            </div>
        </Row>
    </Container> );
}

export default TestimonialPage;